import { render } from "./MatchSideInfoMobile.vue?vue&type=template&id=8fc2eea8&scoped=true"
import script from "./MatchSideInfoMobile.vue?vue&type=script&lang=js"
export * from "./MatchSideInfoMobile.vue?vue&type=script&lang=js"

import "./MatchSideInfoMobile.vue?vue&type=style&index=0&id=8fc2eea8&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fc2eea8"]])

export default __exports__